import { deleteInvoicePayment } from "../../api/invoiceService";

export const useDeleteInvoicePayment = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInvoicePayment(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete invoice payment:", error);
            throw error;
        }
    };

    return { remove };
};